import React, { useState } from 'react';
import { CalendarIcon } from 'lucide-react';
export const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const filterPortfolio = (category: string) => {
    setActiveCategory(category);
  };
  const portfolioItems = [{
    category: 'email',
    title: 'Welcome Email Series',
    client: 'Starlight Pixel',
    description: '7-email welcome journey that builds trust and turns subscribers into loyal customers in one week.',
    previewLabel: 'Email 1: Welcome & Story (Day 1)',
    previewContent: <>
          <strong data-id="element-411">Subject Line:</strong> Welcome to your transformation journey
          ✨
          <br data-id="element-412" />
          <strong data-id="element-413">Preview Text:</strong> Your first step toward organized bliss
          starts here...
          <br data-id="element-414" />
          <strong data-id="element-415">Header:</strong> Hey girl, Welcome to the Starlight Pixel
          family!
          <br data-id="element-416" />
          <strong data-id="element-417">Subheader:</strong> I'm Diluvina, and I'm so grateful you're
          here. Can I share something with you?
          <br data-id="element-418" />
          <strong data-id="element-419">CTA:</strong> Hit reply and tell me: what's your biggest
          organization challenge right now? I read every email and would love to
          hear from you.
          <br data-id="element-420" />
          <strong data-id="element-421">Body:</strong> Sticky notes everywhere. Missed appointments.
          Forgotten birthdays. I felt like I was failing at everything that
          mattered. My work demanded attention. My home was chaos. But I was
          scattered. Overwhelmed. Exhausted. That's when I discovered...
          <br data-id="element-422" />
        </>,
    stats: [{
      number: '42%',
      label: 'Open Rate'
    }, {
      number: '15%',
      label: 'Conversion Rate'
    }, {
      number: '$150k',
      label: 'Revenue Generated'
    }]
  }, {
    category: 'Video Script',
    title: 'YouTube Introduction Script',
    client: 'The Wizard Mobile Welding Channel',
    description: 'YouTube channel on the process of turning his passion into his full time business.',
    previewLabel: 'Video Introduction Script',
    previewContent: <>
          <strong data-id="element-423">HOOK (0-15 seconds):</strong>
          <br data-id="element-424" />
          <br data-id="element-425" />
          [Show welding sparks, then cut to Christian with a slight grin]
          <br data-id="element-426" />
          "So picture this: A plant manager shows me a piece of equipment that
          looks like it went through a blender, points at it, and says 'Can you
          fix this?' Three other welders had already said no. That's when they
          discovered why I'm called The Wizard."
          <br data-id="element-427" />
          <br data-id="element-428" />
          <strong data-id="element-429">
            INTRODUCTION (15-45 seconds)
            <br data-id="element-430" />
          </strong>
          [Cut to professional welding footage mixed with mobile setup]
          <br data-id="element-431" />
          <br data-id="element-432" />
          "Welcome to The Wizard Mobile Welding Channel! I'm Christian Garza,
          and yes, people actually call me The Wizard - not because I wear a
          pointy hat to work, though that would be pretty epic. I earned that
          nickname by...
          <br data-id="element-433" />
          <br data-id="element-434" />
        </>,
    stats: [{
      number: '295%',
      label: 'Conversion Increase'
    }, {
      number: '-65%',
      label: 'Bounce Rate'
    }, {
      number: '3.2min',
      label: 'Avg. Time on Page'
    }]
  }, {
    category: 'ads',
    title: 'Facebook Ad Campaign',
    client: 'Patino Landscaping',
    description: 'High-converting Facebook ads for Landscaping services in the Midwest Suburbs of Chicago.',
    previewLabel: 'Facebook Ad - 3 Variations of the Ad',
    previewContent: <>
          <strong data-id="element-435">
            TOP OF FUNNEL (TOF) - First Time Viewers/Prospecting :
          </strong>
          <br data-id="element-436" />
          <br data-id="element-437" />
          <strong data-id="element-438">Headline :</strong> "Is Your Yard Making Your Home Look Older
          Than It Is?"
          <br data-id="element-439" />
          <br data-id="element-440" />
          <strong data-id="element-441">Body :</strong> Most homeowners in Chicago suburbs would say
          yes after just 2 seasons of neglect. This is because your landscape is
          lacking these 3 essential elements: proper maintenance, professional
          design, and attention to detail - making your property look less
          attractive and hurting your home's value.
          <br data-id="element-442" />
          <br data-id="element-443" />
          We've developed a proven landscaping system that transforms overgrown,
          neglected yards into...
        </>,
    stats: [{
      number: '$0.42',
      label: 'Cost Per Click'
    }, {
      number: '12.8%',
      label: 'Conversion Rate'
    }, {
      number: '4.2x',
      label: 'ROAS'
    }]
  }];
  const filteredItems = activeCategory === 'all' ? portfolioItems : portfolioItems.filter(item => item.category === activeCategory);
  return <div className="w-full bg-white" data-id="element-444">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#000000] to-[#764ba2] text-white text-center py-24" data-id="element-445">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-446">
          <h1 className="text-4xl sm:text-5xl font-bold mb-5 leading-tight" data-id="element-447">
            My Portfolio
          </h1>
          <p className="text-xl opacity-90 max-w-2xl mx-auto" data-id="element-448">
            See the copy that turns browsers into buyers and visitors into
            customers.
          </p>
        </div>
      </section>
      {/* Filter Navigation */}
      <section className="bg-gray-50 py-8 border-b border-gray-200" data-id="element-449">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-450">
          <div className="flex justify-center flex-wrap gap-4" data-id="element-451">
            <button className={`px-6 py-3 rounded-full border-2 font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${activeCategory === 'all' ? 'bg-[#16a34a] text-white border-[#16a34a]' : 'bg-white text-gray-600 border-gray-300 hover:bg-[#16a34a] hover:text-white hover:border-[#16a34a]'}`} onClick={() => filterPortfolio('all')} data-id="element-452">
              All Work
            </button>
            <button className={`px-6 py-3 rounded-full border-2 font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${activeCategory === 'email' ? 'bg-[#16a34a] text-white border-[#16a34a]' : 'bg-white text-gray-600 border-gray-300 hover:bg-[#16a34a] hover:text-white hover:border-[#16a34a]'}`} onClick={() => filterPortfolio('email')} data-id="element-453">
              Email Campaigns
            </button>
            <button className={`px-6 py-3 rounded-full border-2 font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${activeCategory === 'Video Script' ? 'bg-[#16a34a] text-white border-[#16a34a]' : 'bg-white text-gray-600 border-gray-300 hover:bg-[#16a34a] hover:text-white hover:border-[#16a34a]'}`} onClick={() => filterPortfolio('Video Script')} data-id="element-454">
              Video Scripts
            </button>
            <button className={`px-6 py-3 rounded-full border-2 font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${activeCategory === 'sales' ? 'bg-[#16a34a] text-white border-[#16a34a]' : 'bg-white text-gray-600 border-gray-300 hover:bg-[#16a34a] hover:text-white hover:border-[#16a34a]'}`} onClick={() => filterPortfolio('sales')} data-id="element-455">
              Sales Pages
            </button>
            <button className={`px-6 py-3 rounded-full border-2 font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${activeCategory === 'ads' ? 'bg-[#16a34a] text-white border-[#16a34a]' : 'bg-white text-gray-600 border-gray-300 hover:bg-[#16a34a] hover:text-white hover:border-[#16a34a]'}`} onClick={() => filterPortfolio('ads')} data-id="element-456">
              Ad Copy
            </button>
            <button className={`px-6 py-3 rounded-full border-2 font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${activeCategory === 'marketing' ? 'bg-[#16a34a] text-white border-[#16a34a]' : 'bg-white text-gray-600 border-gray-300 hover:bg-[#16a34a] hover:text-white hover:border-[#16a34a]'}`} onClick={() => filterPortfolio('marketing')} data-id="element-457">
              Marketing Content
            </button>
          </div>
        </div>
      </section>
      {/* Portfolio Grid */}
      <section className="py-16" data-id="element-458">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-459">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-460">
            {filteredItems.length > 0 ? filteredItems.map((item, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl" data-id="element-461">
                  <div className="p-8 bg-gradient-to-br from-gray-50 to-gray-100 border-b border-gray-200" data-id="element-462">
                    <span className="inline-block bg-[#16a34a] text-white px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-463">
                      {item.category.charAt(0).toUpperCase() + item.category.slice(1)}
                    </span>
                    <h3 className="text-2xl font-bold text-[#2c3e50] mb-2" data-id="element-464">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 mb-3" data-id="element-465">{item.client}</p>
                    <p className="text-gray-700" data-id="element-466">{item.description}</p>
                  </div>
                  <div className="p-8 bg-white" data-id="element-467">
                    <div className="text-sm font-semibold text-[#16a34a] uppercase tracking-wider mb-4" data-id="element-468">
                      {item.previewLabel}
                    </div>
                    <div className="bg-gray-50 border-l-4 border-[#16a34a] p-5 rounded-lg font-serif italic text-[#2c3e50] leading-relaxed mb-6" data-id="element-469">
                      {item.previewContent}
                    </div>
                    {item.title === 'Welcome Email Series' ? <a href="https://docs.google.com/document/d/1NGZRBK-IsXyrM2ss6LM2gdTB4yr_s5No7h3GDnQy174/edit?tab=t.0#heading=h.duxp6lotmjy0" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#16a34a] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md" data-id="element-470">
                        View More Content
                      </a> : item.title === 'YouTube Introduction Script' ? <a href="https://docs.google.com/document/d/1x1Tl85JkL_4Qx-K5FuCZs3-uEm6G2_w7EDBAKgdMYdg/edit?tab=t.0" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#16a34a] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md" data-id="element-471">
                        View More Content
                      </a> : item.title === 'Facebook Ad Campaign' ? <a href="https://docs.google.com/document/d/14WGB1_lYXc9LwRycU0CYTy3gqT33gshapKiGQqEaLUI/edit?tab=t.0#heading=h.ngacj1nuujjo" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#16a34a] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md" data-id="element-472">
                        View More Content
                      </a> : <button onClick={() => filterPortfolio(item.category)} className="inline-block bg-[#16a34a] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-md" data-id="element-473">
                        View More Content
                      </button>}
                  </div>
                </div>) : <div className="col-span-2 text-center py-20" data-id="element-474">
                <div className="text-6xl mb-6 opacity-50" data-id="element-475">📝</div>
                <div className="text-xl font-medium text-gray-700 mb-2" data-id="element-476">
                  No work samples in this category yet
                </div>
                <div className="text-gray-500" data-id="element-477">
                  Check back soon for more examples
                </div>
              </div>}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#2c3e50] text-white text-center py-16" data-id="element-478">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-479">
          <h2 className="text-4xl font-bold mb-5" data-id="element-480">Ready for Copy Like This?</h2>
          <p className="text-xl opacity-90 mb-10 max-w-2xl mx-auto" data-id="element-481">
            Let's create high-converting copy that drives real results for your
            business.
          </p>
          <a href="https://calendly.com/mayhave/30min" className="inline-flex items-center justify-center px-8 py-4 bg-[#16a34a] text-white text-lg font-semibold rounded-full shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl" data-id="element-482">
            <CalendarIcon className="mr-2 h-5 w-5" data-id="element-483" />
            Get Your Copy Strategy Call
          </a>
        </div>
      </section>
    </div>;
};